import { styled } from 'styled-components';

import { ViewImage } from '../../enums';

export const Container = styled.div`
  height: 100vh;
  position: relative;
`;

export const Background = styled.div`
  background: url(${ViewImage.ActionRequiredToAccessPlatformDefaultBg}) center center / cover no-repeat;
  height: 50%;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;
